import { AssetsContract } from '@terra/shared-contracts-assets';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'orchestrator';

export const assetsClient = createTerraOrpcClient({
  contract: AssetsContract,
  serviceName: SERVICE_NAME,
});
